import { Tray, Icon, Button, Size, Theme } from '@busybusy/webapp-react-ui';
import { PlayButton, SafetyGraphic, CheckboxGreenIcon } from 'assets/icons';
import { HeaderDialog } from 'components';
import ButtonTray from 'components/foundation/ButtonTray/ButtonTray';
import ConditionalContainer from 'components/foundation/ConditionalContainer/ConditionalContainer';
import useSlackSafetyReportsAccess from 'containers/settings/integrations/vendors/slack/hooks/useSlackSafetyReportsAccess';
import { useToastDispatch } from 'contexts/ToastContext';
import useOrganizationUiSettingsUpdate from 'hooks/models/organization/settings/hooks/useOrganizationUiSettingsUpdate';
import { t } from 'i18next';
import { useState } from 'react';

export interface ISafetyTrialDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const SafetyTrialDialog = (props: ISafetyTrialDialogProps) => {
  const { isOpen, onClose } = props;

  const safetyReportsAccess = useSlackSafetyReportsAccess('dashboard-card');
  const updateUiSettings = useOrganizationUiSettingsUpdate();
  const toastDispatch = useToastDispatch();
  const [showErrorTip, setShowErrorTip] = useState(false);

  async function handleStartTrial() {
    let requestSuccessful = false;

    try {
      const response = await safetyReportsAccess();
      requestSuccessful = response.status === 200;
    } catch (e) {
      requestSuccessful = false;
    }

    if (requestSuccessful) {
      updateUiSettings('requestedSafetyReportsAccess', true);
      onClose();
    } else {
      toastDispatch({
        type: 'OPEN',
        payload: { label: t('Failed to send request. Try again later.'), theme: Theme.DANGER },
      });
      setShowErrorTip(true);
    }
  }

  return (
    <HeaderDialog isOpen={isOpen} onClose={onClose} title={''} divider={false} className={'trial-dialog'}>
      <div className={'px-10 pb-10'}>
        <Icon svg={SafetyGraphic} className={'safety-graphic'} />
        <div className={'trial-header'}>
          <h2 className={'my-4'}>{t('Safety Free Trial')}</h2>
          <div className={'my-6 fc-2'}>{t('Your free trial will include the following safety modules:')}</div>
        </div>
        <div className={'check-mark-list'}>
          <Tray className={'m-4'}>
            <Icon svg={CheckboxGreenIcon} className={'mx-1'} />
            <div className={'mx-2'}>{t('Inspections')}</div>
          </Tray>
          <Tray className={'m-4'}>
            <Icon svg={CheckboxGreenIcon} className={'mx-1'} />
            <div className={'mx-2'}>{t('Incidents')}</div>
          </Tray>
          <Tray className={'m-4'}>
            <Icon svg={CheckboxGreenIcon} className={'mx-1'} />
            <div className={'mx-2'}>{t('Observations')}</div>
          </Tray>
          <Tray className={'m-4'}>
            <Icon svg={CheckboxGreenIcon} className={'mx-1'} />
            <div className={'mx-2'}>{t('Trainings')}</div>
          </Tray>
          <Tray className={'m-4'}>
            <Icon svg={CheckboxGreenIcon} className={'mx-1'} />
            <div className={'mx-2'}>{t('JSA Reports')}</div>
          </Tray>
        </div>
        <div className={'button-tray-container mt-8'}>
          <ButtonTray>
            <Button type={'primary'} onClick={handleStartTrial}>
              {t('Start Trial')}
            </Button>
            <Button type={'secondary'} onClick={() => window.open('https://fast.wistia.com/embed/channel/kd6foal20s')}>
              <Icon svg={PlayButton} className={'mr-2'} size={Size.SMALL} />
              {t('Watch Video')}
            </Button>
          </ButtonTray>
        </div>
      </div>
      <ConditionalContainer condition={showErrorTip}>
        <br />
        {t('* If you have an ad blocker, disable it and try again.')}
      </ConditionalContainer>
    </HeaderDialog>
  );
};

export default SafetyTrialDialog;
